import jsUtils from '@pernod-ricard-global-cms/jsutils';
import Vue from 'vue';
import animations from 'Assets/js/modules/animations';
import { isMobile } from 'Assets/js/components/size-checker';
import Vuex from 'vuex';
import store from 'Assets/js/Vuex/Store/store';
import userInstance from 'Assets/js/Vuex/Store/stores/userInstance';
import cartInstance from 'Assets/js/Vuex/Store/stores/cartInstance';
import Wrapper from 'Templates/pages/productAside/Wrapper/index.vue';

export default function addToCart() {
  const all = document.getElementsByClassName('product-aside-cart');

  Array.from(all).forEach((el) => {
    const options = document.getElementById(el.id);
    if (!isMobile() && el.id.includes('mobile')) {
      return;
    }
    const personalised = document.getElementById('personalisation-input');
    try {
      if (options) {
        jsUtils.loadCss(options.dataset.assetkey, options).then(() => {
          const mountElement = options.children[0];
          animations.fadeIn(options);
          Vue.use(Vuex);
          new Vue({
            name: 'AddToCartWrapper',
            data: { ...mountElement.dataset, options, personalised },
            render: (h) => h(Wrapper),
            userInstance,
            cartInstance,
            store
          }).$mount(mountElement);
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  });
}
